<template>
    <div class="row">

        <div class="col-md-12">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <router-link :to="{name:'cajas-online'}">{{$t("cajasOnline")}}</router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <router-link :to="{name:'online-detail', params:{idBusiness: idBusiness}}">
                            {{onlineDetails.nameBusiness}}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">{{$t("cajonInteligente")}}</li>
                </ol>
            </nav>
        </div>

        <div class="col-md-6" v-if="smartCash">
            <table class="table table-bordered table-striped">
                <thead class="thead-dark">
                <tr>
                    <th>{{$t("moneda")}}</th>
                    <template v-if="!cashGlory">
                    <th>{{$t("nivelReciclador")}}</th>
                    <th>{{$t("totalReciclador")}}</th>
                    </template>
                    <th>{{!cashGlory ? $t("nivelCasete") : 'cantidad'}}</th>
                    <th>{{!cashGlory ? $t("totalCasete") : 'total'}}</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>2.00</td>
                    <template v-if="!cashGlory">
                    <td>{{smartCash.reciclador2}}</td>
                    <td>{{smartCash.reciclador2 *2}}</td>
                    </template>
                    <td>{{smartCash.casete2}}</td>
                    <td>{{smartCash.casete2 *2}}</td>
                </tr>
                <tr>
                    <td>1.00</td>
                    <template v-if="!cashGlory">
                    <td>{{smartCash.reciclador1}}</td>
                    <td>{{(smartCash.reciclador1 *1).toFixed(2)}}</td>
                    </template>
                    <td>{{smartCash.casete1}}</td>
                    <td>{{(smartCash.casete1 *1).toFixed(2)}}</td>
                </tr>
                <tr>
                    <td>0.50</td>
                    <template v-if="!cashGlory">
                    <td>{{smartCash.reciclador50c}}</td>
                    <td>{{(smartCash.reciclador50c * 0.5).toFixed(2)}}</td>
                    </template>
                    <td>{{smartCash.casete50c}}</td>
                    <td>{{(smartCash.casete50c *0.5).toFixed(2)}}</td>
                </tr>
                <tr>
                    <td>0.20</td>
                    <template v-if="!cashGlory">
                    <td>{{smartCash.reciclador20c}}</td>
                    <td>{{(smartCash.reciclador20c *0.2).toFixed(2)}}</td>
                    </template>
                    <td>{{smartCash.casete20c}}</td>
                    <td>{{(smartCash.casete20c *0.2).toFixed(2)}}</td>
                </tr>
                <tr>
                    <td>0.10</td>
                    <template v-if="!cashGlory">
                    <td>{{smartCash.reciclador10c}}</td>
                    <td>{{(smartCash.reciclador10c *0.1).toFixed(2)}}</td>
                    </template>
                    <td>{{smartCash.casete10c}}</td>
                    <td>{{(smartCash.casete10c *0.1).toFixed(2)}}</td>
                </tr>
                <tr>
                    <td>0.05</td>
                    <template v-if="!cashGlory">
                    <td>{{smartCash.reciclador5c}}</td>
                    <td>{{(smartCash.reciclador5c *0.05).toFixed(2)}}</td>
                    </template>
                    <td>{{smartCash.casete5c}}</td>
                    <td>{{(smartCash.casete5c *0.05).toFixed(2)}}</td>
                </tr>
                <tr>
                    <td>0.02</td>
                    <template v-if="!cashGlory">
                    <td>{{smartCash.reciclador2c}}</td>
                    <td>{{(smartCash.reciclador2c *0.02).toFixed(2)}}</td>
                    </template>
                    <td>{{smartCash.casete2c}}</td>
                    <td>{{(smartCash.casete2c *0.02).toFixed(2)}}</td>
                </tr>
                <tr>
                    <td>0.01</td>
                    <template v-if="!cashGlory">
                    <td>{{smartCash.reciclador1c}}</td>
                    <td>{{(smartCash.reciclador1c *0.01).toFixed(2)}}</td>
                    </template>
                    <td>{{smartCash.casete1c}}</td>
                    <td>{{(smartCash.casete1c *0.01).toFixed(2)}}</td>
                </tr>

                </tbody>
                <tfoot>
                <tr class="table-success" >
                    <td><strong>{{$t("total")}}:</strong></td>
                    <template v-if="!cashGlory">
                    <td align="right"><strong>{{getTotalTable1NivelReci}}</strong></td>
                    <td align="right"><strong>{{getTotalTable1TotalReci | currency}}</strong></td>
                    </template>
                    <td align="right"><strong>{{getTotalTable1NivelCasete}}</strong></td>
                    <td align="right"><strong>{{getTotalTable1TotalCasete | currency}}</strong></td>
                </tr>
                </tfoot>
            </table>
        </div>

        <div class="col-md-6" v-if="smartCash">
            <table class="table table-bordered table-striped">
                <thead class="thead-dark">
                <tr>
                    <th>{{$t("moneda")}}</th>
                    <template v-if="!cashGlory">
                    <th>{{$t("nivelReciclador")}}</th>
                    <th>{{$t("totalReciclador")}}</th>
                    </template>
                    <th>{{!cashGlory ? $t("nivelCasete") : $t('cantidadMinusculas')}}</th>
                    <th>{{!cashGlory ? $t("totalCasete") : $t('totalMinusculas')}}</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>500.00</td>
                    <template v-if="!cashGlory">
                    <td>{{smartCash.reciclador500}}</td>
                    <td>{{(smartCash.reciclador500 *500).toFixed(2)}}</td>
                    </template>
                    <td>{{smartCash.casete500}}</td>
                    <td>{{(smartCash.casete500 *500).toFixed(2)}}</td>
                </tr>
                <tr>
                    <td>200.00</td>
                    <template v-if="!cashGlory">
                    <td>{{smartCash.reciclador200}}</td>
                    <td>{{(smartCash.reciclador200 *200).toFixed(2)}}</td>
                    </template>
                    <td>{{smartCash.casete200}}</td>
                    <td>{{(smartCash.casete200 *200).toFixed(2)}}</td>
                </tr>
                <tr>
                    <td>100.00</td>
                    <template v-if="!cashGlory">
                    <td>{{smartCash.reciclador100}}</td>
                    <td>{{(smartCash.reciclador100 *100).toFixed(2)}}</td>
                    </template>
                    <td>{{smartCash.casete100}}</td>
                    <td>{{(smartCash.casete100 *100).toFixed(2)}}</td>
                </tr>
                <tr>
                    <td>50.00</td>
                    <template v-if="!cashGlory">
                    <td>{{smartCash.reciclador50}}</td>
                    <td>{{(smartCash.reciclador50 *50).toFixed(2)}}</td>
                    </template>
                    <td>{{smartCash.casete50}}</td>
                    <td>{{(smartCash.casete50 *50).toFixed(2)}}</td>
                </tr>
                <tr>
                    <td>20.00</td>
                    <template v-if="!cashGlory">
                    <td>{{smartCash.reciclador20}}</td>
                    <td>{{(smartCash.reciclador20 *20).toFixed(2)}}</td>
                    </template>
                    <td>{{smartCash.casete20}}</td>
                    <td>{{(smartCash.casete20 *20).toFixed(2)}}</td>
                </tr>
                <tr>
                    <td>10.00</td>
                    <template v-if="!cashGlory">
                    <td>{{smartCash.reciclador10}}</td>
                    <td>{{(smartCash.reciclador10 *10).toFixed(2)}}</td>
                    </template>
                    <td>{{smartCash.casete10}}</td>
                    <td>{{(smartCash.casete10 *10).toFixed(2)}}</td>
                </tr>
                <tr>
                    <td>5.00</td>
                    <template v-if="!cashGlory">
                    <td>{{smartCash.reciclador5}}</td>
                    <td>{{(smartCash.reciclador5 *5).toFixed(2)}}</td>
                    </template>
                    <td>{{smartCash.casete5}}</td>
                    <td>{{(smartCash.casete5 *5).toFixed(2)}}</td>
                </tr>
                </tbody>
                <tfoot>
                <tr class="table-success" >
                    <td><strong>{{$t("total")}}:</strong></td>
                    <td align="right"><strong>{{getTotalTable2NivelReci }}</strong></td>
                    <template v-if="!cashGlory">
                    <td align="right"><strong>{{getTotalTable2TotalReci | currency}}</strong></td>
                    <td align="right"><strong>{{getTotalTable2NivelCasete }}</strong></td>
                    </template>
                    <td align="right"><strong>{{getTotalTable2TotalCasete | currency}}</strong></td>
                </tr>
                </tfoot>
            </table>
        </div>
        <div class="col-md-4">
            <h3 style='padding:10px; border: 1px dashed black; background-color:#eee; margin-top:10px;'><strong>{{$t("totalMonedas")}}: <template v-if="cashGlory">{{getTotalTable1TotalCasete | currency}}</template><template v-else> {{getTotalTable1TotalCasete + getTotalTable1TotalReci  | currency}}</template> </strong></h3>
        </div>
        <div class="col-md-4">
            <h3 style='padding:10px; border: 1px dashed black; background-color:#eee; margin-top:10px;'><strong>{{$t("totalBilletes")}}: <template v-if="cashGlory">{{getTotalTable2TotalCasete | currency}}</template><template v-else> {{getTotalTable2TotalCasete + getTotalTable2TotalReci | currency}} </template></strong></h3>
        </div>
        <div class="col-md-4">
            <h3 style='padding:10px; border: 1px dashed black; background-color:#dff0d8; margin-top:10px;'><strong>{{$t("total")}}: <template v-if="cashGlory">{{getTotalTable1TotalCasete  + getTotalTable2TotalCasete | currency}}</template><template v-else>{{getTotalTable1TotalCasete + getTotalTable1TotalReci + getTotalTable2TotalCasete + getTotalTable2TotalReci | currency}}</template> </strong></h3>
        </div>
    </div>
</template>
<script>

    import swal from 'sweetalert2'
    import {Switch,ButtonGroup,Button} from 'element-ui'

    export default {
        created() {
            this.$store.dispatch("setNameRoute", this.$i18n.t("cajasOnlineTickets"));

            this.getConfigTpv();

            this.getOnlineDetails();

        },
        data() {
            return {
                idBusiness: this.$route.params.idBusiness,
                onlineDetails: {},
                smartCash:[],

                cashGlory:false,
            }
        },
        components: {
            [Button.name]: Button,
            [Option.name]: Option,
            [ButtonGroup.name]:ButtonGroup
        },
        computed:{

            getTotalTable1NivelReci(){

                var total=this.smartCash.reciclador2+this.smartCash.reciclador1+this.smartCash.reciclador50c+this.smartCash.reciclador20c+this.smartCash.reciclador10c+this.smartCash.reciclador5c+this.smartCash.reciclador2c+this.smartCash.reciclador1c;

                return total;
            },

            getTotalTable1TotalReci(){

                var total=(this.smartCash.reciclador2*2)+(this.smartCash.reciclador1*1)+(this.smartCash.reciclador50c*0.5)+(this.smartCash.reciclador20c*0.2)+(this.smartCash.reciclador10c*0.1)+(this.smartCash.reciclador5c*0.05)+(this.smartCash.reciclador2c*0.02)+(this.smartCash.reciclador1c*0.01);

                return total;
            },

            getTotalTable1NivelCasete(){


                    var total=this.smartCash.casete2+this.smartCash.casete1+this.smartCash.casete50c+this.smartCash.casete20c+this.smartCash.casete10c+this.smartCash.casete5c+this.smartCash.casete2c+this.smartCash.casete1c;


                return total;
            },

            getTotalTable1TotalCasete(){

                var total=(this.smartCash.casete2*2)+(this.smartCash.casete1*1)+(this.smartCash.casete50c*0.5)+(this.smartCash.casete20c*0.2)+(this.smartCash.casete10c*0.1)+(this.smartCash.casete5c*0.05)+(this.smartCash.casete2c*0.02)+(this.smartCash.casete1c*0.01);

                return total;
            },


            getTotalTable2NivelReci(){

                var total=this.smartCash.reciclador500+this.smartCash.reciclador200+this.smartCash.reciclador100+this.smartCash.reciclador50+this.smartCash.reciclador20+this.smartCash.reciclador10+this.smartCash.reciclador5;

                return total;
            },

            getTotalTable2TotalReci(){

                
                var total=(this.smartCash.reciclador500*500)+(this.smartCash.reciclador200*200)+(this.smartCash.reciclador100*100)+(this.smartCash.reciclador50*50)+(this.smartCash.reciclador20*20)+(this.smartCash.reciclador10*10)+(this.smartCash.reciclador5*5);

                return total;
            },

            getTotalTable2NivelCasete(){

                var total=this.smartCash.casete500+this.smartCash.casete200+this.smartCash.casete100+this.smartCash.casete50+this.smartCash.casete20+this.smartCash.casete10+this.smartCash.casete5;

                return total;
            },

            getTotalTable2TotalCasete(){

                var total=(this.smartCash.casete500*500)+(this.smartCash.casete200*200)+(this.smartCash.casete100*100)+(this.smartCash.casete50*50)+(this.smartCash.casete20*20)+(this.smartCash.casete10*10)+(this.smartCash.casete5*5);

                return total;
            },


        },
        methods: {
            getConfigTpv() {

                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        jwt: this.$store.getters.jwt,
                        numConfig:16,
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.$store.dispatch("setIdBusiness", this.idBusiness);
                this.axios.get(this.$store.getters.apiUrl + "general/getConfigTpv", config)
                    .then(function (response) {
                        if (response.data.response) {

                            vm.cashGlory = true;

                        }

                    })
                    .catch(function (error) {
                        console.log(error);
                    });


            },
            getOnlineDetails() {
                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "online/getOnlineDetails", config)
                    .then(function (response) {
                        if (response.data.response) {
                            vm.onlineDetails = response.data.result;
                            vm.getSmartCash();
                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            getSmartCash() {

                var tpvs = [];
                this.onlineDetails.listTpvs.forEach(function (x) {
                    if (x && x.online) {
                        tpvs.push(x.idTpv);
                    }
                });


                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        listTpv: JSON.stringify(tpvs),
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "online/getSmartCash", config)
                    .then(function (response) {
                        if (response.data.response) {
                            vm.smartCash = response.data.result;


                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

        }
    }
</script>
<style scoped>
    .card-body {
        padding: 10px 15px;
    }

    #tabletotalventa td {
        padding: 5px 15px;
    }

    .wrap-chart {
        margin-top: 10px;
        padding: 0px;
    }

    .foot-total tr td {
        font-size: 1.2em;
        color: #fff;
        text-shadow: 1px 1px #111;
        font-weight: bold;
    }

    .check-tpv {
        padding-left: 1em;
    }

    .check-tpv label {
        margin-bottom: 0px;
    }

    .check-tpv label:hover {
        cursor: pointer;
    }

    .progress {
        height: 10px !important;
        margin-bottom: 0px;
    }

    .progresstpv td {
        border-top: none;
    }

    .card-columns {
        column-count: 2;

    }

    @media (max-width: 767.98px) {
        .card-columns {
            column-count: 1;

        }
    }


</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Online/OnlineCajonInteligente.vue